import { useState, useEffect } from 'react'


export const useLegendData = (url) => {
  const [data , setData] = useState({ layers: [] })
  useEffect(() => {
    async function fetchData() {
      const response = await fetch(url + '/legend?f=pjson')
      if (response.ok) {
        const legendData = await response.json()
        if (legendData && legendData.layers && legendData.layers.length) {
          setData(legendData)
        }
      }
    }
    fetchData()
  }, [url])

  return data
}